import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';

// supplier-validation.utils.ts
export const CANADIAN_PROVINCES = [
  'AB','BC','MB','NB','NL','NS','NT','NU','ON','PE','QC','SK','YT'
];

// -------------------------
// Validation Functions
// -------------------------

export function isRequired(value: any): boolean {
  return value !== null && value !== undefined && value.toString().trim() !== '';
}

export function minLength(value: string, length: number): boolean {
  return !value || value.length >= length;
}

export function isCountrySelected(value: any): boolean {
  return Array.isArray(value) && value.length > 0 && value[0].name?.trim() !== '';
}

export function maxLength(value: string, length: number): boolean {
  return !value || value.length <= length;
}


export function isNumeric(value: string): boolean {
  return /^[0-9]+$/.test(value);
}

export function isAlphanumeric(value: string): boolean {
  return /^[A-Za-z0-9 ]+$/.test(value);
}

export function isFutureDate(value: string): boolean {
  if (!value) return false;
  const inputDate = new Date(value);
  return inputDate > new Date();
}

export function isProvince(value: string): boolean {
  return value.length > 0;
}
export function isCountry(value: string): boolean {
  return value[0] ? true : false;
}

export function isPostalCode(value: string): boolean {
  if (!value) return false;
  value = value.trim(); // remove leading/trailing spaces
  return /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/.test(value);
}

// -------------------------
// Error Messages
// -------------------------
export const ERROR_MESSAGES: Record<string, string> = {
  required: 'This field is required',
  minlength: 'Value is too short',
  maxlength: 'Value is too long',
  numeric: 'Only numbers are allowed',
  alphanumeric: 'Only letters and numbers allowed',
  futureDate: 'Date must be in the future',
  invalidProvince: 'Please select a Province',
  invalidCountry : 'Please select a Country',
  postalCode: 'Invalid Canadian postal code',
};
